import { layerConfig } from "../fetchLayerConfig";
export const filterGameEvent = (event, source) => {
    const { eventsFilterArray } = layerConfig;
    if (eventsFilterArray === undefined || source !== undefined) {
        return false;
    }
    return eventsFilterArray.includes(event);
};
